/* Reeled In Supply - shared behaviour.
   Every lookup is guarded: one null reference here would halt the whole file
   and leave every .reveal element stuck at opacity 0. */
(function () {
  'use strict';

  /* ---------- scroll reveal ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('in'); });
    }
  }

  /* ---------- sticky header shadow + mega offset ----------
     There can be two headers in the document: the cinematic one that floats
     over a dark hero, and the pill used on every page that opens on bone.
     Only one is ever visible, so measurements come from that one. */
  var headers = Array.prototype.slice.call(document.querySelectorAll('.c-hdr,.b-hdr'));
  function activeHdr() {
    for (var i = 0; i < headers.length; i++) if (!headers[i].hidden) return headers[i];
    return null;
  }
  var hdr = activeHdr();
  function onScroll() {
    var stuck = window.scrollY > 8;
    headers.forEach(function (h) { h.classList.toggle('stuck', stuck); });
  }
  function setMegaTop() {
    var h = activeHdr();
    if (!h) return;
    var r = h.getBoundingClientRect();
    document.documentElement.style.setProperty('--mega-top', Math.max(0, r.bottom) + 'px');
  }
  window.addEventListener('scroll', function () { onScroll(); setMegaTop(); }, { passive: true });
  window.addEventListener('resize', setMegaTop);
  onScroll(); setMegaTop();

  /* ---------- floating chrome only over a dark hero ----------
     The L2 header is white type with no background. That reads over the home,
     about and contact heroes and is invisible on every page that opens on
     bone, so it only floats when the active page starts with a hero.
     activeRoot() covers both builds: the single-file build swaps .pv sections,
     the folder build has one page per document. */
  /* Must match DARK_HERO in build.py. Home, about and contact open on a dark
     hero and keep the floating header; every other page starts on bone, where
     white chrome type is invisible, so those take the pill. */
  var CINEMATIC = /(^|\s)(c-hero|ab-hero|hero)(\s|$)/;
  function activeRoot() {
    return document.querySelector('.pv:not([hidden])')
        || document.getElementById('main')
        || document.getElementById('MainContent');
  }
  function opensDark() {
    /* On Shopify the template already knows the answer and says so on <body>,
       which is the only reliable signal there: <main> is called MainContent,
       and every section is wrapped in its own div, so the old test looked at a
       .shopify-section wrapper, found no hero class, and left the header solid
       black sitting on top of the hero video. */
    if (document.body.classList.contains('reeled-hero-page')) return true;
    var root = activeRoot();
    if (!root) return false;
    var first = root.firstElementChild;
    /* step through Shopify's section wrapper if there is one */
    if (first && first.classList.contains('shopify-section')) {
      first = first.firstElementChild || first;
      /* our sections wrap their markup in .reeled */
      if (first && first.classList.contains('reeled')) first = first.firstElementChild || first;
    }
    return !!(first && CINEMATIC.test(first.className || ''));
  }
  function setChromeMode() {
    var dark = opensDark();
    headers.forEach(function (h) {
      var cinematic = h.classList.contains('c-hdr');
      /* only the single-file build ships both, and there the wrong one is
         hidden outright rather than just restyled */
      if (headers.length > 1) h.hidden = cinematic !== dark;
      if (cinematic) h.classList.toggle('over', dark);
    });
    /* the cinematic corner links belong to the cinematic header */
    document.querySelectorAll('.c-corner').forEach(function (c) {
      if (headers.length > 1) c.hidden = !dark;
    });
    hdr = activeHdr();
    setMegaTop();
  }
  setChromeMode();
  window.addEventListener('hashchange', function () { setTimeout(setChromeMode, 0); });

  /* ---------- mobile drawer ---------- */
  /* both headers carry their own burger, so bind every one of them */
  var burgers = Array.prototype.slice.call(document.querySelectorAll('.burger'));
  var burger = burgers[0] || null;
  var drawer = document.getElementById('drawer');
  var dClose = document.getElementById('drawerClose');
  var lastBurger = burger;
  function openDrawer(open) {
    if (!drawer || !burger) return;
    if (open) drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.toggle('open', open); });
    burgers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.body.style.overflow = open ? 'hidden' : '';
    if (!open) setTimeout(function () { if (!drawer.classList.contains('open')) drawer.hidden = true; }, 340);
    if (open) { var f = drawer.querySelector('a,button'); if (f) f.focus(); }
    else if (lastBurger) lastBurger.focus();
  }
  if (burger && drawer) {
    burgers.forEach(function (b) {
      b.addEventListener('click', function () {
        lastBurger = b;
        openDrawer(!drawer.classList.contains('open'));
      });
    });
    if (dClose) dClose.addEventListener('click', function () { openDrawer(false); });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { openDrawer(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) openDrawer(false);
    });
  }

  /* data-cat is a space separated token list. Matching it with indexOf treats
     it as one string, so a short token like `l` matches the `l` in `apparel`
     and every card passes. Compare tokens. */
  function hasTok(el, tok) {
    return (el.getAttribute('data-cat') || '').split(/\s+/).indexOf(tok) > -1;
  }

  /* ---------- best-seller filter tabs ---------- */
  var tabs = document.querySelectorAll('.tab[data-filter]');
  var pgrid = document.getElementById('pgrid');
  if (tabs.length && pgrid) {
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        t.setAttribute('aria-selected', 'true');
        var f = t.getAttribute('data-filter');
        pgrid.querySelectorAll('.pcard').forEach(function (c) {
          c.style.display = (f === 'all') || hasTok(c, f) ? '' : 'none';
        });
      });
    });
  }

  /* ---------- kit builder ---------- */
  var kitRows = document.querySelectorAll('.kit-row');
  var kitLines = document.getElementById('kitLines');
  var kitTotal = document.getElementById('kitTotal');
  var kitEmpty = document.getElementById('kitEmpty');
  var kitShip = document.getElementById('kitShip');
  if (kitRows.length && kitLines && kitTotal && kitEmpty && kitShip) {
    var kit = [];
    function renderKit() {
      kitLines.innerHTML = '';
      var total = 0;
      kit.forEach(function (i) {
        total += i.price;
        var li = document.createElement('li');
        var a = document.createElement('span'); a.textContent = i.name;
        var b = document.createElement('span'); b.textContent = '$' + i.price.toFixed(2);
        li.appendChild(a); li.appendChild(b);
        kitLines.appendChild(li);
      });
      kitTotal.textContent = '$' + total.toFixed(2);
      kitEmpty.style.display = kit.length ? 'none' : '';
      var left = 100 - total;
      kitShip.textContent = left > 0
        ? 'Add $' + left.toFixed(2) + ' for free shipping'
        : 'Free shipping unlocked';
    }
    kitRows.forEach(function (row) {
      var btn = row.querySelector('.kit-add');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var name = row.getAttribute('data-name') || '';
        var price = parseFloat(row.getAttribute('data-price') || '0');
        var idx = kit.findIndex(function (k) { return k.name === name; });
        if (idx > -1) { kit.splice(idx, 1); row.classList.remove('on'); btn.textContent = 'Add'; }
        else { kit.push({ name: name, price: price }); row.classList.add('on'); btn.textContent = 'Added'; }
        renderKit();
      });
    });
    renderKit();
  }

  /* ---------- collection filters + sort ---------- */
  var collGrid = document.getElementById('collGrid');
  var pCount = document.getElementById('pCount');
  var sortSel = document.getElementById('sortSel');
  var fInputs = document.querySelectorAll('.fopt input[data-f]');
  var reapply = function () {};
  if (collGrid) {
    var cards = Array.prototype.slice.call(collGrid.querySelectorAll('.pcard'));
    var order = cards.slice();
    var empty = document.getElementById('collEmpty');
    function applyColl() {
      /* Checking two boxes in one group widens the result, checking across two
         groups narrows it. Treating every box as AND meant Hats plus Beanies
         returned nothing, which reads as a broken filter rather than a choice. */
      var groups = [];
      fInputs.forEach(function (i) {
        if (!i.checked) return;
        var g = i.closest('.fgroup') || collGrid;
        var slot = groups.filter(function (s) { return s.g === g; })[0];
        if (!slot) { slot = { g: g, toks: [] }; groups.push(slot); }
        slot.toks.push(i.getAttribute('data-f'));
      });
      var shown = 0;
      order.forEach(function (c) {
        var ok = groups.every(function (s) {
          return s.toks.some(function (t) { return hasTok(c, t); });
        });
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
        collGrid.appendChild(c);
      });
      if (pCount) pCount.textContent = shown;
      if (empty) empty.hidden = shown > 0;

      /* drawer footer and the toolbar badge track the same numbers */
      var active = 0;
      fInputs.forEach(function (i) { if (i.checked) active++; });
      document.querySelectorAll('[data-filters-count]').forEach(function (el) {
        el.textContent = shown + (shown === 1 ? ' product' : ' products');
      });
      document.querySelectorAll('[data-filters-badge]').forEach(function (el) {
        el.textContent = active;
        el.hidden = active === 0;
      });
    }
    reapply = applyColl;
    fInputs.forEach(function (i) { i.addEventListener('change', applyColl); });
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var v = sortSel.value;
        order = cards.slice();
        if (v === 'lo') order.sort(function (a, b) { return num(a) - num(b); });
        if (v === 'hi') order.sort(function (a, b) { return num(b) - num(a); });
        if (v === 'az') order.sort(function (a, b) { return nm(a).localeCompare(nm(b)); });
        applyColl();
      });
    }
    function num(el) { return parseFloat(el.getAttribute('data-price') || '0'); }
    function nm(el) { return el.getAttribute('data-name') || ''; }
  }

  /* ---------- drag to scroll ----------
     The About timeline says "drag sideways" and a touch does exactly that,
     but a pointer drag did nothing: the copy only told the truth on a phone.
     Pointer Events cover mouse, trackpad and stylus while leaving native touch
     scrolling alone, which is smoother than anything reimplemented here. */
  document.querySelectorAll('.ab-track').forEach(function (t) {
    var down = false, startX = 0, startLeft = 0, moved = 0;
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = 0;
      startX = e.clientX; startLeft = t.scrollLeft;
      t.classList.add('dragging');
    });
    t.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      /* snapping fights a drag, so it is suspended until the pointer lifts */
      t.style.scrollSnapType = 'none';
      t.scrollLeft = startLeft - dx;
      e.preventDefault();
    });
    function end() {
      if (!down) return;
      down = false;
      t.classList.remove('dragging');
      t.style.scrollSnapType = '';
    }
    t.addEventListener('pointerup', end);
    t.addEventListener('pointercancel', end);
    t.addEventListener('pointerleave', end);
    /* a drag that ends on a link should not also follow it */
    t.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });

  /* ---------- drawer disclosures ---------- */
  /* Buttons, not links, so the drawer's close-on-link-click does not fire when
     you are only opening a section. */
  document.querySelectorAll('.dnav-h').forEach(function (h) {
    h.addEventListener('click', function () {
      h.setAttribute('aria-expanded',
        h.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
  });

  /* ---------- filter rail: groups + mobile drawer ---------- */
  document.querySelectorAll('.fgroup-h').forEach(function (h) {
    h.addEventListener('click', function () {
      h.setAttribute('aria-expanded',
        h.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
  });

  var rail = document.getElementById('collFilters');
  if (rail) {
    var openBtn = document.querySelector('[data-filters-open]');
    function setDrawer(open) {
      document.documentElement.classList.toggle('filters-open', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
      if (open) {
        var first = rail.querySelector('.filters-x');
        if (first) first.focus();
      } else if (openBtn) {
        openBtn.focus();
      }
    }
    document.querySelectorAll('[data-filters-open]').forEach(function (b) {
      b.addEventListener('click', function () { setDrawer(true); });
    });
    document.querySelectorAll('[data-filters-close]').forEach(function (b) {
      b.addEventListener('click', function () { setDrawer(false); });
    });
    document.querySelectorAll('[data-filters-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        fInputs.forEach(function (i) { i.checked = false; });
        reapply();
      });
    });
    /* tap the dimmed page to dismiss, same as a Shopify drawer */
    document.addEventListener('click', function (e) {
      if (!document.documentElement.classList.contains('filters-open')) return;
      if (!rail.contains(e.target) && !e.target.closest('[data-filters-open]')) {
        setDrawer(false);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });
    /* leaving mobile with the drawer open would otherwise lock body scroll */
    var mq = window.matchMedia('(min-width:901px)');
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(
      function () { if (mq.matches) setDrawer(false); });
    reapply();
  }

  /* ---------- cart line removal ---------- */
  /* Remove used to be a link back to the same page, which looked clickable and
     did nothing. The real cart is Shopify's; this at least behaves. */
  document.querySelectorAll('.cline .rm').forEach(function (b) {
    b.addEventListener('click', function () {
      var line = b.closest('.cline');
      if (!line) return;
      line.style.transition = 'opacity .2s';
      line.style.opacity = '0';
      setTimeout(function () { line.remove(); }, 200);
    });
  });

  /* ---------- product gallery ---------- */
  var stageImg = document.getElementById('stageImg');
  var thumbs = document.querySelectorAll('.thumb[data-src]');
  if (stageImg && thumbs.length) {
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
        stageImg.src = t.getAttribute('data-src');
      });
    });
  }

  /* ---------- size picker ---------- */
  var sizes = document.querySelectorAll('.size');
  if (sizes.length) {
    sizes.forEach(function (s) {
      s.addEventListener('click', function () {
        if (s.classList.contains('oos')) return;
        sizes.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        s.setAttribute('aria-pressed', 'true');
      });
    });
  }

  /* ---------- quantity ---------- */
  var qMinus = document.getElementById('qMinus');
  var qPlus = document.getElementById('qPlus');
  var qVal = document.getElementById('qVal');
  if (qMinus && qPlus && qVal) {
    var q = 1;
    function setQ(n) { q = Math.max(1, Math.min(99, n)); qVal.textContent = q; }
    qMinus.addEventListener('click', function () { setQ(q - 1); });
    qPlus.addEventListener('click', function () { setQ(q + 1); });
  }

  /* ---------- accordions (one open at a time) ---------- */
  var accItems = document.querySelectorAll('.acc-i');
  if (accItems.length) {
    accItems.forEach(function (item) {
      var head = item.querySelector('.acc-h');
      var body = item.querySelector('.acc-b');
      if (!head || !body) return;
      if (item.classList.contains('open')) body.style.maxHeight = body.scrollHeight + 'px';
      head.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        accItems.forEach(function (o) {
          var ob = o.querySelector('.acc-b'), oh = o.querySelector('.acc-h');
          if (!ob || !oh) return;
          o.classList.remove('open'); ob.style.maxHeight = null; oh.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          body.style.maxHeight = body.scrollHeight + 'px';
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- sticky mobile action bar ---------- */
  var mbar = document.getElementById('mbar');
  if (mbar) {
    var mbarOn = function () {
      var past = window.scrollY > 380;
      var drawerOpen = drawer && drawer.classList.contains('open');
      mbar.classList.toggle('show', past && !drawerOpen);
    };
    window.addEventListener('scroll', mbarOn, { passive: true });
    window.addEventListener('resize', mbarOn);
    burgers.forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(mbarOn, 20); });
    });
    mbarOn();
  }

  /* ---------- about: sticky media swaps with the active chapter ---------- */
  var abSticky = document.getElementById('abSticky');
  var abChapters = document.querySelectorAll('.ab-chapter[data-ch]');
  if (abSticky && abChapters.length && 'IntersectionObserver' in window) {
    var frames = abSticky.querySelectorAll('img[data-ch]');
    var show = function (ch) {
      frames.forEach(function (f) {
        f.classList.toggle('on', f.getAttribute('data-ch') === ch);
      });
    };
    var chObs = new IntersectionObserver(function (entries) {
      // pick the entry closest to the middle of the viewport
      var best = null;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
      });
      if (best) show(best.target.getAttribute('data-ch'));
    }, { rootMargin: '-35% 0px -35% 0px', threshold: [0.1, 0.5, 0.9] });
    abChapters.forEach(function (c) { chObs.observe(c); });
  }

  /* ---------- contact: reason chips drive the topic select ---------- */
  var reasons = document.querySelectorAll('.reason[data-topic]');
  var topicSel = document.getElementById('cTopic');
  if (reasons.length) {
    reasons.forEach(function (r) {
      r.addEventListener('click', function () {
        reasons.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        r.setAttribute('aria-pressed', 'true');
        var topic = r.getAttribute('data-topic');
        if (topicSel) {
          for (var i = 0; i < topicSel.options.length; i++) {
            if (topicSel.options[i].text === topic) { topicSel.selectedIndex = i; break; }
          }
        }
        var msg = document.getElementById('cMsg');
        if (msg) msg.focus({ preventScroll: false });
      });
    });
  }

  /* ---------- contact: copy the email address ---------- */
  var copyBtn = document.getElementById('copyEmail');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var val = copyBtn.getAttribute('data-copy') || '';
      var done = function () {
        var old = copyBtn.textContent;
        copyBtn.textContent = 'Copied';
        copyBtn.classList.add('done');
        setTimeout(function () {
          copyBtn.textContent = old;
          copyBtn.classList.remove('done');
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(val).then(done, function () {});
      } else {
        // older browsers, and file:// where the clipboard API is blocked
        var ta = document.createElement('textarea');
        ta.value = val;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  }

  /* ---------- hero video fallback ---------- */
  var hv = document.getElementById('heroVid');
  if (hv) {
    hv.addEventListener('error', function () { hv.style.display = 'none'; }, true);
    var src = hv.querySelector('source');
    if (src) src.addEventListener('error', function () { hv.style.display = 'none'; });
  }
})();
